/**
 * Stories handled by ZillowNavbar
 */
/* eslint-disable local-rules/require-storybook-documentation */
import { FunctionComponent } from 'react';
import { TestID } from 'src/common/TestID';
import { ZILLOW_NAVBAR_STATIC_TEST_IDS } from '../../constants';
import { HamburgerButton } from './components/ZillowNavbarHamburgerButton';
import { ZillowNavbarHamburgerBox } from './components/ZillowNavbarHamburgerBox';
import { HamburgerProps } from './types';
import { ZillowNavbarHamburgerInner } from './components/ZillowNavbarHamburgerInner';

export const ZillowNavbarHamburger: FunctionComponent<HamburgerProps> = ({ isMobileNavOpen, version, onClick }) => (
    <HamburgerButton
        onClick={onClick}
        {...new TestID(ZILLOW_NAVBAR_STATIC_TEST_IDS.HAMBURGER).getCypressTestIDAttribute()}
        className="hamburger"
        type="button"
        aria-label={isMobileNavOpen ? 'Close navigation' : 'Open navigation'}>
        <ZillowNavbarHamburgerBox>
            <ZillowNavbarHamburgerInner version={version} isMobileNavOpen={isMobileNavOpen} />
        </ZillowNavbarHamburgerBox>
    </HamburgerButton>
);
